import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import EventRequests from "../EventRequests/EventRequests";

const COPY = {
  title: "Event Requests",
  subtitle: "You Can View Accept & Reject Event Requests",
  searchPlaceholder: "Search Here",
};

const EventRequestsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getEventRequests");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <EventRequests driverData={items} />
    </AdminPage>
  );
};

export default EventRequestsAdmin;
